
export default {
    name: 'LeeSlideImage',
    inheritAttrs: false,
    data() {
        return {
            posx: 0,
            movex: 0,
            isdown: false,
            oldx: 0,
            curpage: 1,
            sw: 0
        }
    },
    mounted() {
        this.sw = window.innerWidth
        window.addEventListener('resize', () => {
            this.sw = window.innerWidth
        })

    },
    methods: {
        slideto(xh) {
            this.curpage=xh
        },
        mousedown() {
            this.isdown = true
            this.oldx = event.pageX
        },
        mousemove() {
            if (this.isdown) {
                this.movex = (event.pageX - this.oldx)
                if (this.curpage === 1) {//如果当前在第一张
                    if (this.movex > 0) {
                        this.movex = (event.pageX - this.oldx) * 0.4
                    }
                }
                if (this.curpage === this.config.length) {//如果当前在第一张
                    if (this.movex < 0) {
                        this.movex = (event.pageX - this.oldx) * 0.4
                    }
                }
            }
        },
        mouseup() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0

        },
        mouseleave() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0

        },
        touchstart() {
            this.isdown = true
            this.oldx = event.targetTouches[0].pageX
        },
        touchmove() {
            if (this.isdown) {
                this.movex = (event.targetTouches[0].pageX - this.oldx)
                if (this.curpage === 1) {//如果当前在第一张
                    if (this.movex > 0) {
                        this.movex = (event.targetTouches[0].pageX - this.oldx) * 0.4
                    }
                }
                if (this.curpage === this.config.length) {//如果当前在第一张
                    if (this.movex < 0) {
                        this.movex = (event.targetTouches[0].pageX - this.oldx) * 0.4
                    }
                }
            }
        },
        touchend() {
            this.isdown = false
            if (this.movex + this.posx >= 0) {
                this.curpage = 1
            } else if (this.movex + this.posx <= -this.sw * (this.config.length - 1)) {
                this.curpage = this.config.length

            } else {
                if (this.movex < 0) {//左滑动
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage++
                    }
                } else {
                    if (Math.abs(this.movex) >= this.sw / 6) {//滑动的距离大于1/4的屏幕
                        this.curpage--
                    }
                }
            }
            this.movex = 0
        },
        gb() {
            this.$emit('input', false)
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false //默认default
        },
        config: {
            type: Array,
            default() {
                return []
            }
        }

    },
    watch: {
        sw: {
            immediate: true,
            handler(value) {
                this.posx = -value * (this.curpage - 1)
            }
        },
        curpage: {
            immediate: true,
            handler(value) {
                this.posx = -this.sw * (value - 1)
            }
        },
        value: {
            immediate: true,
            handler(value) {
                if (!value) {
                    this.posx = 0
                    this.movex = 0
                    this.curpage = 1
                }
            }
        }
    },
};
